import axiosClient from "../../api/axiosClient";
import customNotification from "../../components/notification";
import moment from "moment";

const ratingFeedbackModel = {
    state: [],
    reducers: {
        setData(state, payload) {
            return { ...state, [payload.name]: payload.data,...payload };
        },
    },
    effects: (dispatch) => ({
        async addratingFeedbackModelData(payload) {
            await axiosClient.post('/content/up_rating_feedback', payload).then(res => {
                if (res.data.status === 200) {
                    // getBalanceData(payload)
                    this.getratingFeedbackModelShow(payload)
                    customNotification(res.data.message, "success")
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        },
        async getratingFeedbackModelShow(payload) {
            await axiosClient.post('/content/rating_feedback', payload).then(res => {
                if (res.data.status === 200) {
                   this.setData({ name: "feedback", data: res.data });
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        }
    }),
};

export default ratingFeedbackModel;